import axios from 'axios';
import qs from 'qs';

import { getUrlContext, getCurrentLanguage } from '@/helpers/AppHelpers';

// Retourne la date/heure du dernier élément modifié dans Magnolia
function getLastModified(liste) {
  return liste && liste.length > 0
    ? liste.reduce((max, obj) => (max['mgnl:lastModified'] > obj['mgnl:lastModified'] ? max : obj))[
        'mgnl:lastModified'
      ]
    : null;
}

export default {
  // contentApp : ['/produitCasino', '/produitCollection', 'progresif', etc...]
  // uuid : uuid Magnolia
  getJel(contentApp, uuid) {
    return axios
      .get(getUrlContext(process.env.VUE_APP_REST_JEL.replace('CONTENT_APP', contentApp)), {
        params: {
          'jcr:uuid': uuid,
          lang: getCurrentLanguage(),
        },
      })
      .then((response) => response.data.results[0]);
  },

  // contentApp : ['/produitCasino', '/produitCollection', 'progresif', etc...]
  // listeUuid : tableau de uuid, null=tous
  getJelListe(contentApp, listeUuid = null) {
    const params = {
      lang: getCurrentLanguage(),
    };

    if (listeUuid) {
      if (!Array.isArray(listeUuid) || listeUuid.length == 0) {
        throw new Error(`getJelListe(${contentApp}): doit recevoir un array d'au moins un élément`);
      }
      const listeUuidString = listeUuid.join('|');
      params['jcr:uuid'] = listeUuidString;
    }

    return axios
      .get(getUrlContext(process.env.VUE_APP_REST_JEL.replace('CONTENT_APP', contentApp)), {
        params,
      })
      .then((response) => response.data.results);
  },

  // contentApp : ['/produitCasino', '/produitCollection', 'progresif', etc...]
  // liste dans la quelle on doit trouver la dernière date de modification
  getJelListeMAJ(contentApp, liste) {
    const params = {
      'mgnl:lastModified[gt]': getLastModified(liste),
      lang: getCurrentLanguage(),
    };

    return axios
      .get(getUrlContext(process.env.VUE_APP_REST_JEL.replace('CONTENT_APP', contentApp)), {
        params,
        paramsSerializer: (params) => {
          // Les crochets doivent être encodés hors env. de développement
          return qs.stringify(params);
        },
      })
      .then((response) => response.data.results);
  },
  // TODO: Cette fonction n'a pas sa place ici. "jel" est générique est sert à plusieurs content apps.
  getInstants() {
    return axios
      .get(`/json-cache/instants/liste-pages-jeux`, {
        params: {
          lang: getCurrentLanguage(),
        },
      })
      .then((response) => {
        return response.data;
      });
  },
};
